import { render, staticRenderFns } from "./mailings-stats-detailed-table-filter.vue?vue&type=template&id=494ca8f4&"
import script from "./mailings-stats-detailed-table-filter.vue?vue&type=script&lang=js&"
export * from "./mailings-stats-detailed-table-filter.vue?vue&type=script&lang=js&"
import style0 from "./mailings-stats-detailed-table-filter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports